import React, { memo } from 'react';
interface CTAButtonProps {
  href: string;
  text: string;
  subtext?: string;
  className?: string;
}
export const CTAButton = memo(function CTAButton({
  href,
  text,
  subtext,
  className = ''
}: CTAButtonProps) {
  return <a href={href} className={`inline-flex flex-col items-center justify-center w-full max-w-xl mx-auto text-center rounded-2xl py-5 px-8 transition-all duration-200
        bg-green-500 hover:bg-green-400
        shadow-[0_6px_0_rgb(21,128,61)] hover:shadow-[0_3px_0_rgb(21,128,61)]
        hover:translate-y-[3px] active:translate-y-[6px] active:shadow-none
        gap-1.5 ${className}`} data-id="element-58">
      <span className="text-[15px] md:text-xl font-black uppercase tracking-wide text-white leading-tight" data-id="element-59">
        {text}
      </span>
      {subtext && <span className="text-[11px] md:text-xs font-medium text-white/75 leading-snug" data-id="element-60">
          {subtext}
        </span>}
    </a>;
});